import { useEffect, useId } from 'react';
import { setUnsavedChanges } from './unsaved-changes.js';

/** Register this form as holding unsaved input while `dirty` is true; unregisters on unmount. */
export function useUnsavedChanges(dirty) {
  const key = useId();
  useEffect(() => {
    setUnsavedChanges(key, Boolean(dirty));
    return () => setUnsavedChanges(key, false);
  }, [key, dirty]);
}
